module.exports = __webpack_public_path__ + "static/media/MD_TutorialSlides_10202020_17_Effects.40e1fe52.png";